module.exports = __webpack_public_path__ + "img/access-pen.54d03843.svg";